import { render, staticRenderFns } from "./CarouselCoverFlowModule.vue?vue&type=template&id=27bb142f&"
import script from "./CarouselCoverFlowModule.ts?vue&type=script&lang=ts&"
export * from "./CarouselCoverFlowModule.ts?vue&type=script&lang=ts&"
import style0 from "./CarouselCoverFlowModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports